import React, { Component } from "react";
import Config from "../../../Config";
import "./app_card_status.css";
import LanguageBloc from "../../../bloc/language_bloc";

export default class app_card_status extends Component {

  getStatus(){
    let quotationStatus = ''
    this.props.status === 'Proposal Proceeded' ? quotationStatus = 'GENERATED':
    this.props.status === 'Quotation Created' ?quotationStatus = 'PENDING':
    this.props.status === 'Draft' ? quotationStatus = 'DRAFT':
    quotationStatus = this.props.status;

    return quotationStatus;
  }
  
  render() {
    return this.getStatus() ? (
      <div
        className={`card-status-container `}
        style={{
          backgroundColor: `${
            Config[this.props.module].statusMapping[this.getStatus()].backgroundColor
          }`,
          color: `${
            Config[this.props.module].statusMapping[this.getStatus()].color
          }`
        }}
      >
        <div className="card-status-title">
          {/* {LanguageBloc.getTextByCode( */}
            {Config[this.props.module].statusMapping[this.getStatus()].display}
          {/* )} */}
        </div>
      </div>
    ) : null;
  }
}
